import { useMainButtonStore } from '@/hooks/useMainButton';
import { useTwa } from '@/app/TwaProvider';
import { cn } from '@/lib/cn';

export function BrowserMainButton() {
  const { isTelegram, safeArea } = useTwa();
  const state = useMainButtonStore((s) => s.state);

  if (isTelegram) return null;
  if (!state || state.visible === false) return null;

  const disabled = state.enabled === false || state.loading;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center"
      style={{ paddingBottom: `calc(0.75rem + ${safeArea.bottom}px)` }}
    >
      <div className="pointer-events-auto w-full max-w-app px-5">
        <button
          onClick={() => !disabled && state.onClick()}
          disabled={disabled}
          className={cn(
            'flex h-[2.625rem] w-full items-center justify-center rounded-full text-base font-semibold transition-all',
            disabled
              ? 'cursor-not-allowed bg-gray-300 text-white'
              : 'bg-accent text-accent-text active:scale-[0.99]',
          )}
        >
          {state.loading ? '...' : state.text}
        </button>
      </div>
    </div>
  );
}
